import { createAction } from 'redux-actions';

const ACTIONS_NAMESPACE = 'RSS_FEED';

export const SET_RSS_FEED_ORDER_BY = `${ACTIONS_NAMESPACE}_SET_RSS_FEED_ORDER_BY`;

export const setRssFeedOrderBy = createAction(SET_RSS_FEED_ORDER_BY,
  rssFeedOrderBy => ({ rssFeedOrderBy }));
